import Layout from '@/layout'

const SeaExportRouter = {
  path: '/SeaExport/:code/:name/:subCode/:subName/:etdStart/:etdEnd/:jobState',
  component: Layout,
  redirect: 'noredirect',
  name: 'SeaExport',
  meta: {
    title: 'seaExport',
    icon: 'daohang-ziliaoguanli',
    // roles: ['subsystem_SEAEXPORT']
    roles: []
  },
  children: [
    {
      path: 'BookingNew',
      component: () => import('@/views/cargo/v0/SeaExport/bookingNew'),
      name: 'SeaBooking',
      meta: { title: 'bookingNew' },
      roles: ['module_fmBookingNew'],
      props: true
    },
    {
      path: 'EDI',
      component: () => import('@/views/cargo/v0/SeaExport/edi'),
      name: 'EDI',
      meta: { title: 'EDI' },
      roles: ['module_SEEDI']
    },
    {
      path: 'BookingVerify',
      component: () => import('@/views/cargo/v0/SeaExport/bookingVerify'),
      name: 'BookingVerify',
      meta: { title: '订舱预审' },
      roles: ['module_fmVerify']
    },
    {
      path: 'IntelligentBooking',
      component: () => import('@/views/cargo/v0/SeaExport/IntelligentBooking'),
      name: 'IntelligentBooking',
      meta: { title: '智能托书识别' },
      roles: []
    },
    {
      path: 'OcrRecognitionSe',
      component: () => import('@/views/cargo/v0/ToolAssistant/ocrRecognition'),
      name: 'OcrRecognitionSe',
      meta: { title: 'ocrRecognition' },
      roles: ['module_OcrRecognition']
    },
    {
      path: 'Document',
      component: () => import('@/views/cargo/v0/SeaExport/document'),
      name: 'Document',
      meta: { title: '提单制作' },
      roles: ['module_SEDocuments']
    },
    {
      path: 'CabinManagement',
      component: () => import('@/views/cargo/v0/SeaExport/cabinManagement'),
      name: 'CabinManagement',
      meta: { title: '舱位管理' },
      roles: ['module_CabinManagement']
    },
    {
      path: 'Vessel',
      component: () => import('@/views/cargo/v0/SeaExport/Vessel/index'),
      name: 'Vessel',
      meta: { title: '船名/航次' },
      roles: ['module_SEVessel']
    },
    {
      path: 'ImportCharge',
      component: () => import('@/views/cargo/v0/SeaExport/ImportCharge/index'),
      name: 'ImportCharge',
      meta: { title: '批量导入费用(海出)' },
      roles: ['module_fmImportChargeSE']
    },
    {
      path: 'LandTransportation',
      component: () => import('@/views/cargo/v0/SeaExport/LandTransportation/index'),
      name: 'LandTransportation',
      meta: { title: '陆运' },
      roles: ['module_fmLandTransportat']
    },
    {
      path: 'FmRouteCenter',
      component: () => import('@/views/cargo/v0/SeaExport/fmRouteCenter'),
      name: 'FmRouteCenter',
      meta: { title: '航线中心' },
      roles: ['module_fmRouteCenter']
    },
    {
      path: 'Warehousing',
      component: () => import('@/views/cargo/v0/SeaExport/Warehousing/index'),
      name: 'Warehousing',
      meta: { title: '仓储' },
      roles: ['module_fmWarehousing']
    },
    {
      path: 'SEBatchUploadFile',
      component: () => import('@/views/cargo/v0/SeaExport/uploadFile/index'),
      name: 'SEBatchUploadFile',
      meta: { title: '上传文件' },
      roles: ['module_fmUploadFile']
    },
    {
      path: 'LandTranQuery',
      component: () => import('@/views/cargo/v0/SeaExport/LandTranQuery/index'),
      name: 'LandTranQuery',
      meta: { title: '陆运(查询)' },
      roles: ['module_fmLandTranQuery']
    },
    {
      path: 'TrajectoryQuery',
      component: () => import('@/views/cargo/v0/SeaExport/TrajectoryQuery/index'),
      name: 'TrajectoryQuery',
      meta: { title: '集装箱动态轨迹查询' },
      roles: ['module_fmTrajectoryQuery']
    },
    {
      path: 'MblManagement',
      component: () => import('@/views/cargo/v0/SeaExport/MblManagement/index'),
      name: 'MblManagement',
      meta: { title: '主单号管理' },
      roles: ['module_mblManagement']
    },
    {
      path: 'CustomsFile',
      component: () => import('@/views/cargo/v0/SeaExport/CustomsFile/index'),
      name: 'CustomsFile',
      meta: { title: '报关' },
      roles: ['module_fmSEFile']
    },
    {
      path: 'StayWarehousingList',
      component: () => import('@/views/cargo/v0/SeaExport/stayWarehousingList'),
      name: 'StayWarehousingList',
      meta: { title: '待入库清单' },
      roles: ['module_StayWarehousingList']
    }
  ]
}

export default SeaExportRouter
